const excludeParamFromSearch = (searchParams: { [key: string]: string }, paramToExclude: string): string => {
  const paramsIterable = Object.entries(searchParams);
  const paramsFiltered = paramsIterable.filter(([key, _]) => key !== paramToExclude);
  return paramsFiltered.reduce((acc, [key, value]) => `${acc}${key}=${value}&`, '');
};

export default excludeParamFromSearch;
